import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { LinkUpActions } from '../actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { SettingsService } from '@services/settings/settings.service';
import { ILinkUp } from '@pdqdev/pdq-shared/dist/interfaces/ILinkUp';

@Injectable()
export class LinkUpEffects {
  loadLinkUpDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LinkUpActions.loadLinkupDetails),
      switchMap(() => {
        return this.settingsService.loadLinkUpDetails().pipe(
          map((linkUpDetails: ILinkUp.Details) => {
            return LinkUpActions.loadLinkupDetailsSuccess({ linkUpDetails });
          }),
          catchError((error) => {
            return of(
              LinkUpActions.loadLinkupDetailsFailure({
                errMsg: error.error,
              }),
            );
          }),
        );
      }),
    ),
  );
  editLinkUpWorkstation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LinkUpActions.editLinkUpWorkstation),
      switchMap(({ params, workstationId }) => {
        return this.settingsService.editLinkUpWorkstation(params, workstationId).pipe(
          map(({ updatedWorkstation }) => {
            return LinkUpActions.editLinkUpWorkstationSuccess({ workstation: updatedWorkstation });
          }),

          catchError((error) => {
            return of(
              LinkUpActions.editLinkUpWorkstationFailure({
                errMsg: error.error,
              }),
            );
          }),
        );
      }),
    ),
  );

  editLinkUpDevice$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LinkUpActions.editLinkUpDevice),
      switchMap(({ params, deviceId }) => {
        return this.settingsService.editLinkUpDevice(params, deviceId).pipe(
          map(({ params, deviceId }) => {
            return LinkUpActions.editLinkUpDeviceSuccess({ params, deviceId });
          }),
          catchError((error) => {
            return of(
              LinkUpActions.editLinkUpDeviceFailure({
                errMsg: error.error,
              }),
            );
          }),
        );
      }),
    ),
  );

  deleteLinkUpWorkstation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LinkUpActions.deleteLinkUpWorkstation),
      switchMap(({ workstationId }) => {
        return this.settingsService.deleteLinkUpWorkstation(workstationId).pipe(
          map((res: any) => {
            return LinkUpActions.deleteLinkUpWorkstationSuccess({ workstationId: res.id });
          }),
          catchError((error) => {
            return of(
              LinkUpActions.deleteLinkUpWorkstationFailure({
                errMsg: error.error,
              }),
            );
          }),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private router: Router,
    private settingsService: SettingsService,
  ) {}
}
